import { CancellablePromise } from './cancellable-promise';

export function wait(duration: number): CancellablePromise<void> {
  const newPromise = new CancellablePromise<void>(res => {
    setTimeout(() => {
      if (!newPromise.isCancelled) {
        res();
      }
    }, duration);
  });

  return newPromise;
}
